// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions
// tslint:disable:no-identical-functions

import { ProductListResponseDto } from '@epicuro-next/data/engagement/engagement-models';
import { EventHandlerPayloadResolveMoment } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import {
  createInstance,
  getIdProvider,
  getProvider,
} from '../../../utils/dynamic-items-utils';
import { configStripSetProductSource, trackListAction } from '../../events';
import {
  getDataLoadingPropertiesForProductSearchFromProductReferences,
  getListDataProperties,
} from '../../lists';
import { PanelStatusEvent } from '../../types/panel-event';

import { getSquarePanelTemplate } from './square-panel-template';

export function createSquarePanelFromList() {
  const propertyNames = {
    listId: 'listId',
  };
  const template = getSquarePanelTemplate(
    'square-panel-products-data-container',
  );

  template.root.data = {
    ...template.root.data,
    [propertyNames.listId]: 'SPECIFY_LIST_ID_HERE',
  };

  const listDataContainer = createInstance({
    id: 'square-panel-list-container',
    contentTypeId: 'dynamic-collections-renderer',
    data: {
      ...getListDataProperties({
        listId: getIdProvider(template.root.id, propertyNames.listId),
      }),
    },
  });
  template.root.children.push(listDataContainer);

  template.headerText.data.headerText = {
    ...getProvider(listDataContainer, 'listData'),
    transform: function (listData: ProductListResponseDto): string {
      return window.neoclesDynamicFramework.recommendationsPanels.methods.decode(
        listData.name,
      );
    }.toString(),
  };

  template.productDataContainer.data = {
    ...getDataLoadingPropertiesForProductSearchFromProductReferences({
      productReferences: getProvider(listDataContainer, 'productReferences'),
      listId: getIdProvider(template.root.id, propertyNames.listId),
    }),
    panelTrackingId: '',
    hasItems: template.productDataContainer.data.hasItems,
    panelName: 'square-panel-from-list',
    panelStyle: 'panel-style-not-configured-yet',
    hasData: {},
  };

  template.onClickEventHandlers.push(
    configStripSetProductSource({
      listIdProvider: getIdProvider(template.root.id, propertyNames.listId),
      panelNameProvider: getProvider(
        template.productDataContainer,
        'panelName',
      ),
      panelTrackingIdProvider: getProvider(
        template.productDataContainer,
        'panelTrackingId',
      ),
    }),
  );

  if (template.root.events !== undefined) {
    throw new Error(
      'Events would be overwritten. Please rewrite the code so no events would get lost.',
    );
  }

  const noItemsPanelStatusEvent = {
    values: [
      getIdProvider(template.productDataContainer.id, 'isLoading'),
      getProvider(template.productDataContainer, 'productData'),
    ],
    filter: function ([isLoading, productData]: [
      boolean,
      undefined | unknown[],
    ]): boolean {
      return (
        !isLoading && (productData === undefined || productData.length === 0)
      );
    }.toString(),
    transform: function (): PanelStatusEvent {
      const event: PanelStatusEvent = {
        type: 'panel-status',
        data: 'hasNoData',
      };

      return event;
    }.toString(),
  };

  const errorPanelStatusEvent = {
    values: [
      {
        ...getProvider(listDataContainer, 'hasError'),
        startWith: {
          value: false,
        },
      },
      {
        ...getIdProvider(template.productDataContainer.id, 'hasError'),
        startWith: {
          value: false,
        },
      },
    ],
    filter: function ([hasErrorFetchingListInfo, hasErrorFetchingProductInfo]: [
      boolean,
      boolean,
    ]): boolean {
      return hasErrorFetchingListInfo || hasErrorFetchingProductInfo;
    }.toString(),
    transform: function () {
      const event: PanelStatusEvent = {
        type: 'panel-status',
        data: 'hasError',
      };

      return event;
    }.toString(),
  };

  template.root.events = [noItemsPanelStatusEvent, errorPanelStatusEvent];

  template.seeMoreLink.eventHandlers = {
    onClick: [
      trackListAction({
        listIdProvider: getIdProvider(template.root.id, propertyNames.listId),
      }),
      configStripSetProductSource(
        {
          listIdProvider: getIdProvider(template.root.id, propertyNames.listId),
          panelNameProvider: getProvider(
            template.productDataContainer,
            'panelName',
          ),
          panelTrackingIdProvider: getProvider(
            template.productDataContainer,
            'panelTrackingId',
          ),
        },
        {
          seeMore: true,
          payloadFetchMoment:
            EventHandlerPayloadResolveMoment.BeforeAddEventListener,
        },
      ),
    ],
  };

  return { ...template };
}

export const squarePanelFromList = createSquarePanelFromList().styleWrapper;
